import React, { Component } from 'react';
import { connect } from 'shalala';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { useStore } from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class FacturasGlobalesItemActions extends Component {
  handleOnDownloadActionClick = async () => {
    const { selectedRowKeys } = this.props;

    await this.props.download(selectedRowKeys);
  };

  render() {
    const { alignRight, selectedRowKeys } = this.props;
    const { actionBusy: busy } = this.props;

    return (
      <>
        <Dropdown
          as={ButtonGroup}
          alignRight={alignRight}
        >
          {selectedRowKeys.length === 1 && (
            <LoadingButton
              variant="secondary"
              loading={busy}
              onClick={this.handleOnDownloadActionClick}
            >
              {busy === true ? 'Descargando' : 'Descargar'}
            </LoadingButton>
          )}

          {/* <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />

          <Dropdown.Menu>
            <Dropdown.Item as="div" onClick={ this.handleOnDownloadActionClick.bind(this, 'zip') }>Cancelar procesamiento</Dropdown.Item>
          </Dropdown.Menu> */}
        </Dropdown>
      </>
    );
  }
}

const mapState = (store) => {
  return {
    actionBusy: store.modulo.fpg.list.actionBusy,
  };
};

const mapActions = (actions) => {
  const { fpg } = actions.modulo;

  return { download: fpg.list.download };
};

export default connect(useStore, mapState, mapActions)(FacturasGlobalesItemActions);
